export class SortSourceAccountsBy {
    'field';
    'order';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "SourceAccountSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortSourceAccountsBy.attributeTypeMap;
    }
    constructor() {
    }
}
